const wholeMould = {
    '01': '公章',
    '02': '财务章',
    '03': '发票章',
    '05': '法人章'
};
export default wholeMould;